import React from 'react';
var ConceptRes = require('../../resources/concept');
import RaisedButton from 'material-ui/RaisedButton';

var EditorStep1 = React.createClass({
  retrieveAllConcepts: function(callback) {
    var _this = this;
    callback = callback || function(){};
    ConceptRes.retrieveUserCourses(function(err, courses) {
      if (err) return;
      var courseCount = courses.length;
      var conceptsArr = [];
      for (var i = 0; i < courses.length; i++) {
        ConceptRes.retrieveConceptTree(courses[i].metadata.concepts[0], function(err2, res) {
          if (err2) return;
          conceptsArr = conceptsArr.concat(res);
          courseCount--;
          if (courseCount <= 0) {
            var conceptObj = {children: conceptsArr};
            var builtData = _this.buildInitialConceptData(conceptObj);
            var conceptLeafMapping = builtData.leaf;
            if (_this.props.updateConceptLeafMapping && typeof _this.props.updateConceptLeafMapping === 'function') {
              _this.props.updateConceptLeafMapping(conceptLeafMapping);
            }
            if (_this.props.updateConceptsMap && typeof _this.props.updateConceptsMap === 'function') {
              _this.props.updateConceptsMap(builtData.map);
            }
            _this.setState({
              concepts: conceptObj,
              conceptMap: builtData.map
            }, function() {
              if (_this.props.updateConcepts && typeof _this.props.updateConcepts === 'function') {
                _this.props.updateConcepts(conceptObj);
              }
              callback();
            })
          }
        })
      }
    })
  },
  buildInitialConceptData: function(concept, result) {
    result = result || {};
    result.map = result.map || {};
    result.leaf = result.leaf || {};
    if (concept._id) result.map[concept._id] = concept;
    if (concept.children.length > 0) {
      concept.activeChildren = concept.children[0];
      for (var i = 0; i < concept.children.length; i++) {
        this.buildInitialConceptData(concept.children[i], result);
      }
    } else {
      result.leaf[concept._id] = concept;
    }
    return result;
  },
  rebuildConceptData: function(conceptId, result) {
    result = result || {};
    var conceptMapping = this.state.conceptMap;
    var concept = conceptMapping[conceptId];
    result = concept;
    if (concept && concept.upperConcept && conceptMapping[concept.upperConcept]) {
      if (conceptMapping[concept.upperConcept]) {
        result = concept;
        conceptMapping[concept.upperConcept].activeChildren = concept;
      }
      // activeArr.push(concept);
      return this.rebuildConceptData(concept.upperConcept, result);
    }
    return result;
  },
  handleChange: function(position, e) {
    var newChosenConcept = this.state.conceptMap[e.target.value];
    var currentConcept = this.state.concepts;
    switch(position) {
      case 0: default: currentConcept.activeChildren = newChosenConcept; break;
      case 1: currentConcept.activeChildren.activeChildren = newChosenConcept; break;
      case 2: currentConcept.activeChildren.activeChildren.activeChildren = newChosenConcept; break;
      case 3: currentConcept.activeChildren.activeChildren.activeChildren.activeChildren = newChosenConcept; break;
    };
    this.setState({
      concepts: currentConcept
    }, function() {
      this.props.onSubjectChange(currentConcept.activeChildren._id);
      this.props.onConceptChange(this.state.concepts);
      this.props.updateConcepts(currentConcept);
    });
  },
  validateBeforNavigating: function() {
    var title = this.state.collection.title ? this.state.collection.title.replace(/ /g, '').trim() : '';
    console.log(title)
    var isValid = !!title;
    if (!isValid) this.setState({errorTitle: true});
    return {
      isValid: !!title
    }
  },

  nextStep: function() {
    if (this.validateBeforNavigating().isValid) {
      this.handleStepChange(1);
    }
  },
  handleStepChange: function(value) {
    this.props.onStepChange(value);
  },
  handleCollectionTitleChange: function(e) {
    var title = e.target.value;
    this.state.collection.title = title;
    this.setState({
      collection: this.state.collection,
      errorTitle: false
    })
  },
  invalidTitleOnSave: function() {
    this.setState({
      errorTitle: true
    })
  },
  getInitialState: function() {
    return {
      concepts: {},
      collection: this.props.collection,
      conceptMap: {},
      isLoading: false
    };
  },
  componentWillMount: function() {

  },
  componentWillReceiveProps: function(nextProps) {
    if (nextProps.collection && nextProps.collection._id && nextProps.collection.questions.length > 0) {
      if (nextProps.collection.questions[0].kquestion.concepts && nextProps.collection.questions[0].kquestion.concepts.length > 0) {
        var concept = nextProps.collection.questions[0].kquestion.concepts[0];
        var activeConcepts = this.rebuildConceptData(concept);
        var concepts = this.state.concepts;
        concepts.activeChildren = activeConcepts;
      }
    }
    this.setState({
      collection: nextProps.collection ? nextProps.collection : this.state.collection
    })
  },
  render: function() {
    var _this = this;
    var content;
    if (!_this.state.isLoading) {
      content = (
        <div>
          <div style={{"marginBottom": "10px"}} className={_this.state.errorTitle ? "has-error" : null}>
            <label className="control-label" style={{"fontSize": "16px", "width": "100px"}}>Title *</label>
            <input
              className="form-control"
              style={{"width": "auto", "minWidth": "250px", "display": "inline-block", "marginRight": "10px" }}
              value={_this.state.collection.title}
              onChange={_this.handleCollectionTitleChange}/>
            {
              _this.state.errorTitle && <span style={{marginLeft: "100px", fontSize: "12px"}} className="help-block">Title field is required!</span>
            }
          </div>
          <hr/>
          <div style={{"marginBottom": "10px"}}>
            {
              _this.state.concepts.activeChildren &&
              <div>
                <label style={{"fontSize": "16px", "width": "100px"}}>Subject</label>
                <select style={{"width": "auto", "minWidth": "200px", "display": "inline-block", "marginRight": "10px" }} className="form-control" onChange={_this.handleChange.bind(null, 0)} value={_this.state.concepts.activeChildren._id}>
                  {
                    _this.state.concepts.children.map(function(concept, index) {
                      return <option value={concept._id} key={index}>{concept.title}</option>;
                    })
                  }
                </select>
              </div>
            }
          </div>
          <div style={{"marginBottom": "10px"}}>
              <label style={{"fontSize": "16px", "width": "100px", float: "left"}}>Concept</label>
              <div style={{marginLeft: "100px"}}>
                {
                  _this.state.concepts.activeChildren && _this.state.concepts.activeChildren.activeChildren &&
                  <select style={{"width": "auto", "minWidth": "200px", "display": "inline-block", "margin": "0 10px 10px 0" }} className="form-control" onChange={_this.handleChange.bind(null, 1)} value={_this.state.concepts.activeChildren.activeChildren._id}>
                    {
                      _this.state.concepts.activeChildren.children.map(function(concept, index) {
                        return <option value={concept._id} key={index}>{concept.title}</option>;
                      })
                    }
                  </select>
                }
                {
                  _this.state.concepts.activeChildren && _this.state.concepts.activeChildren.activeChildren && _this.state.concepts.activeChildren.activeChildren.activeChildren &&
                  <select style={{"width": "auto", "minWidth": "200px", "display": "inline-block", "margin": "0 10px 10px 0" }} className="form-control" onChange={_this.handleChange.bind(null, 2)} value={_this.state.concepts.activeChildren.activeChildren.activeChildren._id}>
                    {
                      _this.state.concepts.activeChildren.activeChildren.children.map(function(concept, index) {
                        return <option value={concept._id} key={index}>{concept.title}</option>;
                      })
                    }
                  </select>
                }
                {
                  _this.state.concepts.activeChildren && _this.state.concepts.activeChildren.activeChildren && _this.state.concepts.activeChildren.activeChildren.activeChildren&& _this.state.concepts.activeChildren.activeChildren.activeChildren.activeChildren &&
                  <select style={{"width": "auto", "minWidth": "200px", "display": "inline-block", "margin": "0 10px 10px 0" }} className="form-control" onChange={_this.handleChange.bind(null, 3)} value={_this.state.concepts.activeChildren.activeChildren.activeChildren.activeChildren._id}>
                    {
                      _this.state.concepts.activeChildren.activeChildren.activeChildren.children.map(function(concept, index) {
                        return <option value={concept._id} key={index}>{concept.title}</option>;
                      })
                    }
                  </select>
                }
              </div>
            </div>
          <div className="float-right" style={{"marginLeft": "100px"}}>
            <RaisedButton
              onClick={this.nextStep}
              label="Add Questions"
              labelPosition="before"
              secondary={true}
              icon={<i style={{"color": "white"}} className="fa fa-angle-right" />}
            />
          </div>
        </div>
      );
    } else {
      content = (<img src="https://cdn.zenquiz.net/static/Assets/loading-animation.gif" alt="loading"/>)
    }
    return (
      <div style={{"marginTop": "15px"}}>
        {content}
      </div>
    )
  },

  componentDidMount: function() {
    var _this = this;
    this.setState({isLoading: true})
    this.retrieveAllConcepts(function() {
      _this.setState({isLoading: false})
      var collection = _this.state.collection;
      if (collection && collection._id && collection.questions && collection.questions.length > 0) {
        var concept = collection.questions[0].kquestion.concepts[0];
        var activeConcepts = _this.rebuildConceptData(concept);
        var concepts = _this.state.concepts;
        concepts.activeChildren = activeConcepts;
        _this.setState({
          concepts: concepts
        })
      }
    });
  }
})

export default EditorStep1;



/** WEBPACK FOOTER **
 ** ./src/components/CollectionEditor/EditorStep1.js
 **/